import { createSelector } from '@reduxjs/toolkit'
import { ICreateProfile } from '../reducer'
import { getPortalBootstrap } from './api/bootstrap'

const rootState = (state: ICreateProfile) => state.createProfile

export const getProfileForm = createSelector(
  rootState,
  (state) => state.profileForm
)

export const getIsAchDebit = createSelector(
  rootState,
  (state) => state.isAchDebit
)

export const getProfileData = createSelector(
  [getPortalBootstrap],
  (data) => data
)
